import { createAction, handleActions } from 'redux-actions';

const SET_IOSTTS = 'iosTTS/SET_IOSTTS';

export const TTSList = createAction(SET_IOSTTS);

const initialState = {
  iosTextList: '',
};

const iosTTS = handleActions(
  {
    [SET_IOSTTS]: (state, { payload: iosTextList }) => iosTextList,
  },
  initialState
);

export default iosTTS;
